import { __assign } from "tslib";
import { noCase } from "no-case";
export function dotCase(input, options) {
  if (options === void 0) {
    options = {};
  }

  return noCase(input, __assign({
    delimiter: "."
  }, options));
}